import { ClientsService } from '../services'

export default (bdParams, type, filters, isSendAll=false) => {
	return new Promise(resolve => {
		ClientsService.newSendRequest(bdParams, type, filters, isSendAll)
			.then(response => resolve(response.data))
	})
}